import React from 'react';
/**
 * `PaymentAssistFailure` renders a simple static page shown when a Payment
 * Assist transaction cannot be completed/validated.
 */

import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

const PaymentAssistFailure = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('page-title.payment-unsuccessful')}</title>
      </Helmet>

      <div>
        Your payment has been unsuccessful on this occasion, please contact
        Payment Assist on 01664 503151
      </div>
    </>
  );
};

export default PaymentAssistFailure;
